import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const HEADLINES = [
    'Movies, TV and gaming collectables',
    'Bring your favourite worlds home',
    'Your favourite worlds, on your shelf',
    'New arrivals from the worlds you love',
];

// Cropping a tall photo to a square can cut the head off a figure
const showTallPhotoWhole = ({ target }) => {
    if (target.naturalHeight > target.naturalWidth * 1.15) target.classList.add('is-tall');
};

const HeroWall = ({ products }) => {
    const [headline] = useState(() => HEADLINES[Math.floor(Math.random() * HEADLINES.length)]);

    return (
        <div className="rd-wall">
            {products.length > 0 && (
            <div className="rd-wall__grid">
                {products.map((product, index) => (
                    <Link key={product._id} to={`/product/${product.slug || product._id}`} className="rd-wall__tile">
                        <img
                            src={product.image}
                            alt={product.name}
                            fetchpriority={index < 3 ? 'high' : undefined}
                            onLoad={showTallPhotoWhole}
                        />
                    </Link>
                ))}
            </div>
            )}
            <div className="rd-wall__copy">
                <h1 id="rd-hero-title">{headline}</h1>
                <div className="rd-wall__actions">
                    <Link to="/search?sort=newest" className="rd-btn rd-btn--primary">Shop New Arrivals</Link>
                    <Link to="/search/" className="rd-btn rd-btn--ghost">Browse All</Link>
                </div>
            </div>
        </div>
    );
};

export default HeroWall;
